<script>

import Lang from './Lang'

export default {
    name: 'dt-header',
    components: {
        'dt-lang': Lang,
    },
    data() {
        return {
        }
    },
}
</script>

<template lang="pug">

header.dt-header
    router-link.dt-header__logo(
        tag="a"
        :class=`{
            'dt-header__logo_disabled': $route.name=='index'||$route.name==''}`
        :to="{name: 'dt-page-index'}"
    )
        dkbr-figure(
            src='/static/pictures/dt/icons/icon_logo.png')
    div.dt-header__title
        span(v-if="isENG") Tensor networks and deep learning<br>for applications in data mining
        span(v-if="isRUS") Тензорные сети и глубинное обучение<br>для интеллектуального анализа данных
    dt-lang.dt-header__lang
</template>

<style lang="sass">

@import '~@dt/sass/root.sass'

.dt-header
    min-height: 150px
    +flex(row, nowrap, space-between, center)
    +padding(0 10px 0 0)
    border-top-right-radius: 20px
    border-top-left-radius: 15px
    +color(dark3, light)
    &__logo
        +width(160px, $milli: 128px, $nano: 80px)
        +margin-r(30px)
        +margin-b(40px)
        +margin-l(-15px, -15px, -15px, -15px, -15px)
        //z-index: 10000
        cursor: pointer
        &_disabled
            cursor: progress
    &__title
        +margin(auto)
        +color-font(light)
        +font(special-huge)
        text-align: center
    &__lang
        +width(80px)
        +height(105px)
        +margin(10px)
</style>



// WEBPACK FOOTER //
// site/deeptensor/components/Header.vue